import PagePlaceholder from '@/components/PagePlaceholder';

export default function SecurityPage() {
  return (
    <PagePlaceholder
      title="Security & Governance"
      subtitle="Your intelligence should remain yours. Enterprise-grade security, privacy and control."
    />
  );
}